var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmptyAttach = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M33.558 30.264L2.892 25.726a1 1 0 01-.843-1.136L5.306 2.58a1 1 0 011.136-.843l30.666 4.538a1 1 0 01.843 1.136l-3.257 22.01a1 1 0 01-1.136.843z",
  stroke: "#7A8595",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.985 10.392l7.695 7.772 9.616-5.21",
  stroke: "#7A8595",
  strokeWidth: 2
})));
export { SvgEmptyAttach as ReactComponent };